
import { Badge } from "@/components/ui/badge";

interface ReferralStatsProps {
  totalReferrals: number;
  paidReferrals: number;
  nextMilestone: number;
}

const ReferralStats = ({ totalReferrals, paidReferrals, nextMilestone }: ReferralStatsProps) => {
  return (
    <div className="text-right">
      <div className="text-sm font-medium">
        <span className="text-[#4A5568]">Referred:</span> 
        <span className="ml-1 text-[#517FA4]">{totalReferrals}</span>
      </div>
      <div className="text-sm font-medium">
        <span className="text-[#4A5568]">Paid subscribers:</span> 
        <span className="ml-1 text-green-600">{paidReferrals}</span>
      </div>
      {paidReferrals > 0 && (
        <div className="text-xs mt-1">
          <span className="text-[#4A5568]">Next reward at:</span> 
          <span className="ml-1 text-[#517FA4]">{nextMilestone} paid referrals</span>
        </div>
      )}
    </div>
  );
};

export default ReferralStats;
